import { render, staticRenderFns } from "./ShippingLayout.vue?vue&type=template&id=5e6b1fca&scoped=true&"
import script from "./ShippingLayout.vue?vue&type=script&lang=js&"
export * from "./ShippingLayout.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLayout.vue?vue&type=style&index=0&id=5e6b1fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b1fca",
  null
  
)

component.options.__file = "ShippingLayout.vue"
export default component.exports